(function () {
    const element = document.getElementById('back-button');

    if (!element) {
        return;
    }

    // Show button only for internal navigation (same domain referrer)
    if (document.referrer && document.referrer.indexOf(location.hostname) !== -1) {
        element.classList.remove('hide');
        element.classList.add('back-button--visible');
    } else {
        // External referrer or direct URL access
        element.classList.add('hide');
        element.classList.remove('back-button--visible');
    }

    // Click event handler with tracking
    element.addEventListener('click', function(e) {
        // Basic tracking for CTR monitoring (as specified in ticket)
        const category = element.getAttribute('data-category') || '';
        const url = element.getAttribute('data-url') || '';
        const buttonTextElement = document.getElementById('back-button-text');
        const buttonText = buttonTextElement ? buttonTextElement.textContent : 'Back';

        // Determine referrer type based on document.referrer
        const referrerType = document.referrer.indexOf(location.hostname) !== -1 ? 'internal' : 'external';

        // Simple tracking event for usage monitoring
        if (typeof window.trackEvent === 'function') {
            window.trackEvent('pdp_back_button_click', {
                category: category,
                referrer_type: referrerType,
                button_text: buttonText,
                has_url: url ? 'true' : 'false'
            });
        }

        // Navigate to specific category URL if available, otherwise use browser history
        if (url) {
            // Navigate directly to the category page (when last_category_id exists)
            window.location.href = url;
        } else {
            // Fall back to browser history for generic back button
            window.history.back();
        }
    });

})();